import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { UPDATE_AD, UPDATE_AD_FAIL, UPDATE_AD_SUCCESS } from '../redux/Ads';
import { PUT } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';

function* upadteAdFlow({ payload: { values, adId, }, }) {
  try {
    const { highlight_1, highlight_2, ...otherParams } = values;
    const highlights = [highlight_1, highlight_2];
    const params = { highlights, ...otherParams, };
    const endpoint = `${apiRoot}/ads/${adId}`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: PUT, endpoint, params: { ad: params, }, });
    yield put(UPDATE_AD_SUCCESS(response));
  } catch (error) {
    yield put(UPDATE_AD_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* UpdateAd() {
  yield takeLatest(UPDATE_AD, upadteAdFlow);
}
